// Slideshow PRG Pagination Handler
document.addEventListener('DOMContentLoaded', function() {
  const slideshowContainers = document.querySelectorAll('slideshow-prg-component');
  
  slideshowContainers.forEach(container => {
    const slideshow = container.querySelector('.slideshow');
    const slides = container.querySelectorAll('.slide');
    const prevButton = container.querySelector('.slider-button--prev');
    const nextButton = container.querySelector('.slider-button--next');
    const counterCurrent = container.querySelector('.slider-counter--current');
    const counterTotal = container.querySelector('.slider-counter--total');
    const paginationDots = container.querySelectorAll('.slider-counter__link');
    const autoplayButton = container.querySelector('.slideshow__autoplay');
    
    if (!slideshow || slides.length <= 1) return;
    
    let currentSlide = 0;
    let autoplayInterval = null;
    let isAutoplayPaused = false;
    
    // Get autoplay settings from data attributes
    const autoplayEnabled = slideshow.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(slideshow.getAttribute('data-speed') || 5) * 1000;
    
    // Initialize slideshow
    function initSlideshow() {
      showSlide(0);
      updatePagination();
      if (autoplayEnabled) {
        startAutoplay();
      }
    }
    
    // Show specific slide
    function showSlide(index) {
      // Hide all slides
      slides.forEach(slide => {
        slide.style.display = 'none';
      });
      
      // Show current slide
      if (slides[index]) {
        slides[index].style.display = 'block';
        currentSlide = index;
      }
      
      updatePagination();
    }
    
    // Update pagination indicators
    function updatePagination() {
      // Update counter
      if (counterCurrent) {
        counterCurrent.textContent = currentSlide + 1;
      }
      
      // Update pagination dots
      paginationDots.forEach((dot, index) => {
        dot.classList.remove('slider-counter__link--active');
        if (index === currentSlide) {
          dot.classList.add('slider-counter__link--active');
        }
      });
    }
    
    // Next slide
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    }
    
    // Previous slide
    function prevSlide() {
      const prevIndex = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
      showSlide(prevIndex);
    }
    
    // Start autoplay
    function startAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
        if (!isAutoplayPaused) {
          nextSlide();
        }
      }, autoplaySpeed);
    }
    
    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    // Toggle autoplay
    function toggleAutoplay() {
      isAutoplayPaused = !isAutoplayPaused;
      if (autoplayButton) {
        autoplayButton.classList.toggle('slideshow__autoplay--paused', isAutoplayPaused);
        autoplayButton.setAttribute('aria-label', isAutoplayPaused ? 'Play slideshow' : 'Pause slideshow');
      }
    }
    
    // Event listeners
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        prevSlide();
        if (autoplayEnabled) {
          stopAutoplay();
          startAutoplay();
        }
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        nextSlide();
        if (autoplayEnabled) {
          stopAutoplay();
          startAutoplay();
        }
      });
    }
    
    // Pagination dot clicks
    paginationDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        if (autoplayEnabled) {
          stopAutoplay();
          startAutoplay();
        }
      });
    });
    
    // Autoplay button
    if (autoplayButton) {
      autoplayButton.addEventListener('click', toggleAutoplay);
    }
    
    // Pause autoplay on hover
    container.addEventListener('mouseenter', () => {
      if (autoplayEnabled && !isAutoplayPaused) {
        isAutoplayPaused = true;
        if (autoplayButton) {
          autoplayButton.classList.add('slideshow__autoplay--paused');
        }
      }
    });
    
    container.addEventListener('mouseleave', () => {
      if (autoplayEnabled && isAutoplayPaused) {
        isAutoplayPaused = false;
        if (autoplayButton) {
          autoplayButton.classList.remove('slideshow__autoplay--paused');
        }
      }
    });
    
    // Keyboard navigation
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
      }
    });
    
    // Initialize
    initSlideshow();
  });
}); 